export default __webpack_public_path__ + "static/media/background-img.c2189431.jpg";